import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AdminPanelStockFormContainer from './AdminPanelStockFormContainer';
import AdminSideSlides from '../../AdminLayout/AdminSideSlides';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import KioskIdelScreen from '../../KioskLayout/KioskIdelScreen';

const messages = defineMessages({
  ScanStockCode: {
    id: 'Admin.Stock.ScanStockCode',
    defineMessages: 'Scan the stock code to begin.'
  }
});

export class AdminPanelStockLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };
  state = {
    stepTitle: '',
    pageTitle:
      this.props && this.props.intl.formatMessage(messages.ScanStockCode),
    height: 300
  };

  render() {
    return (
      <>
        <AdminSideSlides
          pageTitle={this.state.pageTitle}
          customTop={this.state.customTop}
          customHeight={120}
        />
        <AdminPanelStockFormContainer />
        <KioskIdelScreen />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const kiosk = state.get('kiosk');
  return { ...kiosk };
};

export default connect(mapStateToProps)(injectIntl(AdminPanelStockLayout));
